import { FC } from 'react'

import { Cluster, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'
import { Widget, WidgetFooter, WidgetTitle } from '@forto-dev/phoenix-ui-core/ship'

export const WidgetSkeleton: FC<{ count: number }> = ({ count }) => (
  <Stack gap={16}>
    {Array.from({ length: count }).map((_, index) => (
      <Widget key={index}>
        <WidgetTitle>
          <Skeleton variant="badge" />
        </WidgetTitle>
        <WidgetFooter>
          <Cluster>
            {/* TODO: replace with full width skeleton when it's available*/}
            <Skeleton variant="badge" />
          </Cluster>
        </WidgetFooter>
      </Widget>
    ))}
  </Stack>
)
